import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import UnitFactory from "../../Entity/Factories/UnitFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";

export default function* unitUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_UNIT_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_UNIT_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `units/${action.payload?.id}`, action.payload?.unit);
    const unit: UnitInterface = UnitFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_UNIT_UPDATE_SUCCESS,
      payload: {
        unit: unit
      }
    });

    if (!action.payload?.hideSnackbar) {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          type: "success",
          message: Translator.trans("snackbar-message-unit-updated-successfully")
        }
      });
    }

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, unit);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_UNIT_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUnitUpdate() {
  yield takeEvery(Constants.GLOBAL_UNIT_UPDATE_START, unitUpdate);
}
